(() => {
  window.hugosTrack=(event,detail={})=>{
    try{
      const payload={...detail,experience:'carls-purchase-funnel-v1',currency:window.Shopify?.currency?.active||'USD'};
      window.Shopify?.analytics?.publish(event,payload);
      const privacy=window.Shopify?.customerPrivacy;
      if(privacy?.analyticsProcessingAllowed&&!privacy.analyticsProcessingAllowed())return;
      window.dataLayer=window.dataLayer||[];window.dataLayer.push({event,...payload});
    }catch{}
  };
  document.addEventListener('click',event=>{const link=event.target.closest('a[href="#hugos-survey"]');if(link)window.hugosTrack('hugos_cta_click',{source:link.dataset.source||link.closest('section')?.id||'navigation'});});
})();
